// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__fXJ7w","buttons":"styles_buttons__bE8Aj","instructions":"styles_instructions__tSmyR","errorBg":"styles_errorBg__FMLGd","infoBg":"styles_infoBg__BhdGw"};